// extracted by mini-css-extract-plugin
module.exports = {"switch":"oWMtqJ","slider":"PDUJDD","disabled":"Iz2Iuk","round":"T6ebFM","children":"b5_eW8"};